var Curriculog = Curriculog || {};

Curriculog.QueryParams = (function ($, _, Backbone, QueryParams) {

	QueryParams = Curriculog.Param.extend({
		defaults: function() {
			return {
				entity: 0,
				includeEntityChildren: 0,
				ap: 0,
				currentStep: {},
				type: '',
				launchedDateRange: {},
				completedDateRange: {},
				exportedDateRange: {},
				originator: 0,
				role: 0,
				status: [],
				name: '',
				permission: '',
				deadline: 0,
				flag: '',
				empty: 0,
				decision: [],
				showCrosslisting: 1
			};
		},

		initialize: function(model, options) {
			this.setAttr(options);
		},

		setAttr: function(attributes) {
			attributes = _.pick(attributes, _.keys(this.defaults()));
			this.set(attributes);
			return this.attributes;
		},

		validateDateRange: function(dateRange) {
			/*
			Business Rules for Date Ranges:
			Start of time: 01/01/0001
			End of time: now

			dateRange Possible Combinations:
				1. empty object - user wants to ignore the date column in the query
					(default behavior, won't send in params)
				2. date - date (could be the same date)
				3. empty - date
				4. date - empty
				5. empty - empty - user wants all completed proposals with an export date

			Based on cases above, DateRange will send:
				1. exportedDateRange: {}
				2. exportedDateRange: {from: '06/01/2015', to: '06/03/2015'}
				3. exportedDateRange: {from: '01/01/0001', to: '06/03/2015'}
				4. exportedDateRange: {from: '06/01/2015', to: now}
				5. exportedDateRange: {from: '01/01/0001', to: now}
			*/

			var from = dateRange.from,
				to = dateRange.to;

			if (dateRange.from === '') {
				from = '01/01/0001';
			}

			if (dateRange.to === '') {
				var now = new Date();
				to = ('0' + (now.getMonth() + 1)).slice(-2) + '/' +
					('0' + now.getDate()).slice(-2) + '/' +
					now.getFullYear();
			}

			return {
				from: from,
				to: to
			};

		},

	});

	return QueryParams;

})($, _, Backbone, Curriculog.QueryParams || {});